import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { CSS_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { FieldBBErrorType, FieldBBType } from '../fields/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

export const textField = ({
	dictionary,
}: CreationContextFor<typeof COMPONENT_TYPE.TEXT_FIELD>): CreatedBuildingBlock<typeof COMPONENT_TYPE.TEXT_FIELD> =>
	createModel({
		type: COMPONENT_TYPE.TEXT_FIELD,
		editorProps: {
			[UNIFORM_PROPS.fieldErrorShow]: FieldBBErrorType.required,
		},
		componentProps: {
			[UNIFORM_PROPS.fieldType]: FieldBBType.text,
			[UNIFORM_PROPS.fieldPlaceholder]: dictionary.TEXT_FIELD.placeholder.text,
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[CSS_PROPS.field.style.text.phColor]: 'rgba(0, 0, 0, 0.54)',
					},
				},
			},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.TEXT_FIELD>;
